export default __webpack_public_path__ + "static/media/sticker-animation-light@2x.df3168fb.webp";